import {EventEmitter} from "@angular/core";
import {ControlValueAccessor} from "@angular/forms";

const noop = () => {
};

export abstract class ModelListener implements ControlValueAccessor {

    //childs should initialize this field
    abstract onChange: EventEmitter<any>;

    //The internal data model
    _innerValue: any = {};
    //Placeholders for the callbacks which are later providesd
    //by the Control Value Accessor
    abstract onTouchedCallback: EventEmitter<any>;

    valueFormatter(newValue) {
        return newValue;
    }

    keyFormatter(newKey) {
        return newKey;
    }

    writeValue(obj: any): void {
        obj = this.keyFormatter(obj);
        if (obj !== this.innerValue) {
            this.innerValue = obj;
        }
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChange.subscribe(fn);
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback.subscribe(fn);
    }


    //get accessor
    get innerValue(): any {
        return this.valueFormatter(this._innerValue);
    };

    //set accessor including call the onchange callback
    set innerValue(v: any) {
        if (v !== this._innerValue) {
            this._innerValue = v;
            this.onChange.emit(this._innerValue);
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/model-listener/model.listener.ts